export enum AudioCodec {
  PCMU = "PCMU",
  L16 = "L16",
}

export enum MediaEncryption {
  DISABLED = "disabled",
  SRTP = "SRTP",
  DTLS = "DTLS",
}

const MEDIA_ENCRYPTION_VALUES = new Set<string>(Object.values(MediaEncryption))

export function isMediaEncryptionValue(
  value: unknown,
): value is MediaEncryption {
  return typeof value === "string" && MEDIA_ENCRYPTION_VALUES.has(value)
}

export enum WebSocketConnectionMode {
  DIRECT = "direct",
  HTTP_FIRST = "http_first",
  TWIML_WEBHOOK = "twiml_webhook",
}

const WS_CONNECTION_MODES = new Set<string>(
  Object.values(WebSocketConnectionMode),
)

export function isWebSocketConnectionMode(
  value: unknown,
): value is WebSocketConnectionMode {
  return typeof value === "string" && WS_CONNECTION_MODES.has(value)
}

export enum SimulatorType {
  VOICE = "MODEL_TYPE_VOICE",
  OUTBOUND_VOICE = "MODEL_TYPE_OUTBOUND_VOICE",
  TEXT = "MODEL_TYPE_CHAT",
  CHAT_A2A = "MODEL_TYPE_CHAT_A2A",
  SMS = "MODEL_TYPE_SMS",
  WEBSOCKET = "MODEL_TYPE_WEBSOCKET",
  CHAT_WEBSOCKET = "MODEL_TYPE_CHAT_WEBSOCKET",
  LIVEKIT = "MODEL_TYPE_LIVEKIT",
  PIPECAT = "MODEL_TYPE_DAILY",
  NOOP = "MODEL_TYPE_NOOP",
  STT = "MODEL_TYPE_TRANSCRIPTION",
  REALTIME_VOICE_TO_VOICE = "MODEL_TYPE_VOICE_TO_VOICE",
  OPENAI_REALTIME = "MODEL_TYPE_OPENAI_REALTIME",
  GEMINI_REALTIME = "MODEL_TYPE_GEMINI_REALTIME",
  GROK_REALTIME = "MODEL_TYPE_GROK_REALTIME",
  DEEPGRAM_REALTIME = "MODEL_TYPE_DEEPGRAM_REALTIME",
}
